export function usePreventUnload({ isPageActiveRef }) {
  const controller = new AbortController();

  const handleReload = (event) => {
    event?.preventDefault();

    // Chrome requires returnValue to be set.
    if (event) {
      event.returnValue = "";
    }
  };

  const removeListener = () => {
    controller?.abort();
  };

  onBeforeRouteLeave(() => {
    if (unref(isPageActiveRef)) {
      const answer = globalThis?.confirm(
        "Do you really want to leave? \nChanges that you made may not be saved.",
      );

      if (!answer) return false;
    }
  });

  const addListener = () => {
    window?.addEventListener("beforeunload", handleReload, {
      signal: controller?.signal,
    });
  };

  watch(
    isPageActiveRef,
    (active) => {
      if (active) {
        addListener();
      } else {
        removeListener();
      }
    },
    {
      immediate: true,
    },
  );
}
